import React, {Component} from 'react';
import CalendarLeft from "../CalendarLeft";
import CalendarRight from "../CalendarRight";
import {connect} from "react-redux";
import {setLanguage} from "../../actions";
import {translateLang} from "../../constants/traductions";
import './style.css';

class CalendarAvailability extends Component {

  componentDidMount() {

    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');

    switch (lang) {
      case 'en':
        this.props.setLanguage('en');
        break;
      default:
        break;
    }

  }

  render() {

    return (

      <div className="ml-calendar">

        {
          this.props.store.fetchingState === true ?

            <div className="box stack-top" style={{ background: 'white', textAlign: 'center' }} >
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>

            : ''
        }

        {
          this.props.store.serviceState === 'inactive' ?

            <div className="box stack-top" style={{ background: 'black', textAlign: 'center' }} >
              <div className="not-available-text">
                <h2 style={{ textAlign: 'center'}}><strong>- { translateLang('error_not_service', this.props.store.language) } -</strong></h2>
                <h2 style={{ textAlign: 'center'}}><strong>{ translateLang('error_refresh', this.props.store.language) }...</strong></h2>
              </div>

            </div>

            : ''
        }

        <CalendarLeft />

        <CalendarRight />

        <div className="clear"/>

      </div>

    );
  }
}

const mapStateToProps = store => ({
  store
});

const mapDispatchToProps = dispatch => ({
  setLanguage: value => dispatch(setLanguage(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarAvailability);
